<ng-template #basicInfo>
    @if (nameGroup) {
        <form [formGroup]="nameGroup">
            <div class="row header-row">
                <div class="col">
                    <label>{{ 'wizard.basicInformationHeader' | t }}</label>
                </div>
            </div>
            <div class="row centered-row">
                <div class="col left-block">
                    <div class="form-group">
                        <label>{{ 'wizard.nameFieldLabel' | t }}</label>
                        <cerrix-textfield
                            dataUiid="tpa-name"
                            identifier="name"
                            formControlName="name"
                            [placeholder]="'wizard.requiredPlaceholder' | t"
                            inputTooltip
                        >
                        </cerrix-textfield>
                    </div>
                    <div class="form-group">
                        <label>{{ 'wizard.descriptionFieldLabel' | t }}</label>
                        <cerrix-textarea
                            dataUiid="tpa-description"
                            identifier="description"
                            formControlName="description"
                        ></cerrix-textarea>
                    </div>
                </div>
                <div class="col right-block">
                    <div class="form-group">
                        <label>{{ 'wizard.employeeFieldLabel' | t }}</label>
                        <cerrix-textfield
                            dataUiid="tpa-employee"
                            identifier="employee"
                            formControlName="employee"
                            inputTooltip
                        >
                        </cerrix-textfield>
                    </div>
                </div>
            </div>
        </form>
    }
</ng-template>

<ng-template #apiKey>
    @if (apiKeyGroup) {
        <form [formGroup]="apiKeyGroup">
            <div class="row header-row">
                <div class="col">
                    <label>{{ 'wizard.apiKeyDetailsHeader' | t }}</label>
                </div>
            </div>
            <div class="row centered-row">
                <div class="col left-block">
                    <div class="form-group">
                        <label>{{ 'wizard.expirationDateLabel' | t }}</label>
                        <date-input
                            data-uiid="tpa-expirationdate"
                            formControlName="expirationDate"
                            [minDate]="minDate"
                            [maxDate]="maxDate"
                        ></date-input>
                        @if (apiKeyGroup.controls.expirationDate.errors) {
                            <div class="red">
                                @if (apiKeyGroup.controls.expirationDate.errors.expirationDate) {
                                    <p>
                                        {{
                                            apiKeyGroup.controls.expirationDate.errors
                                                .expirationDate
                                        }}
                                    </p>
                                }
                            </div>
                        }
                    </div>
                </div>
                <div class="col right-block">
                    <div class="form-group"></div>
                </div>
            </div>
            @if (apiSoftIpActive) {
                <div class="row centered-row">
                    <div class="col left-block">
                        <div class="form-group">
                            <label>{{ 'wizard.ipRestrictionLabel' | t }}</label>
                            <cerrix-textarea
                                dataUiid="tpa-iprestriction"
                                identifier="ipRestriction"
                                formControlName="ipRestriction"
                                [placeholder]="'wizard.requiredPlaceholder' | t"
                                [required]="true"
                                inputTooltip
                            ></cerrix-textarea>
                        </div>
                    </div>
                    <div class="col right-block">
                        <div class="form-group">
                            <label></label>
                            <div [innerHTML]="'wizard.ipRestrictionHelp' | t"></div>
                        </div>
                    </div>
                </div>
            }
        </form>
    }
</ng-template>

<ng-template #controls>
    @if (controlGroup) {
        <form [formGroup]="controlGroup">
            <div class="row header-row">
                <div class="col">
                    <label>{{ 'wizard.controlsHeader' | t }}</label>
                </div>
            </div>
            <div class="row centered-row">
                <tpa-control-linkable
                    typename="controls"
                    [displayValueProp]="displayProperty"
                    [orderByValueProperty]="true"
                    [linked]="linked"
                    [unlinked]="unlinked"
                    [disabled]="disabled"
                    [hideFilter]="false"
                    [rowIconConfig]="rowIconConfig"
                    [rendererConfig]="rendererConfig"
                    #linkable
                >
                    ></tpa-control-linkable
                >
            </div>
        </form>
    }
</ng-template>

<ng-template #testInformation>
    @if (testInformationGroup) {
        <form [formGroup]="testInformationGroup">
            <div class="row header-row">
                <div class="col">
                    <label>{{ 'wizard.testInformationHeader' | t }}</label>
                </div>
            </div>
            <div class="row centered-row">
                <div class="col left-block">
                    <div class="form-group">
                        <label>{{ 'wizard.testplanTypeLabel' | t }}</label>
                        <ng-select
                            data-uiid="tpa-testplantype"
                            bindValue="ID"
                            bindLabel="Name"
                            formControlName="testplanType"
                            [items]="[{ ID: 1, Name: 'Effectiveness' }]"
                            [clearable]="false"
                        >
                        </ng-select>
                    </div>
                </div>
                <div class="col right-block">
                    <div class="form-group">
                        <label>{{ 'wizard.rangeTestDatesLabel' | t }}</label>
                        <div class="row centered-row">
                            <div class="col">
                                <div class="form-group">
                                    <date-input
                                        data-uiid="tpa-startdate"
                                        formControlName="startDate"
                                    ></date-input>
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <date-input
                                        data-uiid="tpa-enddate"
                                        formControlName="endDate"
                                    ></date-input>
                                </div>
                            </div>
                            @if (testInformationGroup.controls.startDate.errors) {
                                <div class="red">
                                    @if (
                                        testInformationGroup.controls.startDate.errors
                                            .startDateAfterendDate
                                    ) {
                                        <p>
                                            {{
                                                testInformationGroup.controls.startDate.errors
                                                    .startDateAfterendDate
                                            }}
                                        </p>
                                    }
                                </div>
                            }
                            <div class="detail-page-action-bar">
                                <span class="date-edited"
                                    >{{ 'wizard.assurancePartyHint' | t }}</span
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    }
</ng-template>

<!-- Wizard -->
@if (wizardConfig) {
    <cerrix-wizard
        [config]="wizardConfig"
        [templates]="[basicInfo, apiKey, controls, testInformation]"
        #wizard
    >
    </cerrix-wizard>
}
